<template>
  <div
    class="server-error"
    style="background-color: #f6f8fb;">
    <el-card class="error_container">

      <div
        class="mx-24 my-24 el-text el-text--display-medium"
        style="text-align: center;">
        Server Error
      </div>

      <div
        class="mx-24 mb-24"
        style="text-align: center;">
        Server Error
      </div>

    </el-card>
  </div>
</template>

<script>
export default {
  name: 'ServerError'
};
</script>

<style lang="scss" scoped>
  .server-error {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .error_container {
    width: 512px;
  }
</style>
